import { trim } from 'lodash';

export const removeHash = (string: string | undefined) => trim(string, '#');
